import { AspectRatio, aspectRatioList, aspectRatioMap } from "@zickko/shared";

export const getCssClassNameForAspectRatio = (aspectRatio: AspectRatio | null) => {
  if (!aspectRatio) return "";
  const imageAspectRatio = Object.values(aspectRatioList).find((ar) => ar.id === aspectRatio) || aspectRatioMap.square;
  const aspectRatioClassName = `ar-${imageAspectRatio.width}-${imageAspectRatio.height}`;

  // replace all dot to dash to prevent css compile error
  return aspectRatioClassName.replace(/[.]/g, "-");
};
